import { render, staticRenderFns } from "./NoAside.vue?vue&type=template&id=53971608&"
import script from "./NoAside.vue?vue&type=script&lang=js&"
export * from "./NoAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53971608')) {
      api.createRecord('53971608', component.options)
    } else {
      api.reload('53971608', component.options)
    }
    module.hot.accept("./NoAside.vue?vue&type=template&id=53971608&", function () {
      api.rerender('53971608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/aside/NoAside.vue"
export default component.exports